export interface ShareBar {
  label: string;
  /** Already formatted, e.g. "40.00%". */
  value: string;
  /** 0–100, drives the bar width. */
  percent: number;
}

/**
 * Horizontal bars for shares of a whole. The text carries the numbers; the bars are
 * decoration for the eye, so they are hidden from assistive technology.
 */
export function ShareBars({ items }: { items: readonly ShareBar[] }) {
  return (
    <ul className="space-y-3">
      {items.map((item) => (
        <li className="space-y-1" key={item.label}>
          <div className="flex items-baseline justify-between gap-4 text-sm">
            <span className="text-foreground">{item.label}</span>
            <span className="font-medium font-mono text-foreground">
              {item.value}
            </span>
          </div>
          <div
            aria-hidden="true"
            className="h-3 overflow-hidden rounded-full bg-muted"
          >
            <div
              className="h-full rounded-full bg-primary"
              style={{ width: `${Math.min(100, Math.max(0, item.percent))}%` }}
            />
          </div>
        </li>
      ))}
    </ul>
  );
}
